import React from 'react';
import { BottomNavContainer, StyledStickyBottomNav } from './styles';
import { DividerBox } from '../Box/styles';

interface StickyBottomNavProps {
  children?: React.ReactNode;
}

export const StickyBottomNav: React.FC<StickyBottomNavProps> = ({
  children,
}) => {
  return (
    <StyledStickyBottomNav>
      <DividerBox style={{ marginBottom: '16px' }} />
      <BottomNavContainer>{children}</BottomNavContainer>
    </StyledStickyBottomNav>
  );
};
